export enum BazaNcOfferingRegulationType {
    RegA = 'RegA',
    RegAPlus = 'RegA+',
    RegD = 'RegD',
    RegCF = 'RegCF',
}
